import { AdoptionQuoteSection } from '../sections/AdoptionQuoteSection';
import { AudienceTabsSection } from '../sections/AudienceTabsSection';
// TODO: Reintroduce <DocumentationSection /> once the IT/procurement documentation
// is ready to publish.
// import { DocumentationSection } from '../sections/DocumentationSection';
import { InstitutionsFinalCTASection } from '../sections/InstitutionsFinalCTASection';
import { InstitutionsHeroSection } from '../sections/InstitutionsHeroSection';
import { InstitutionsPillarsSection } from '../sections/InstitutionsPillarsSection';
import { PricingSection } from '../sections/PricingSection';
import { ProblemStatementSection } from '../sections/ProblemStatementSection';
import { StakeholderDetailSection } from '../sections/StakeholderDetailSection';
import { UCLATimelineSection } from '../sections/UCLATimelineSection';

import { useDocumentTitle } from '@/hooks/useDocumentTitle';

import styles from './InstitutionsPage.module.css';

export function InstitutionsPage() {
  useDocumentTitle('Institutions');

  return (
    <div className={styles.page}>
      <InstitutionsHeroSection />
      <ProblemStatementSection />
      <AudienceTabsSection />
      <InstitutionsPillarsSection />
      <UCLATimelineSection />
      <PricingSection />
      <StakeholderDetailSection />
      <AdoptionQuoteSection />
      {/* TODO: Reintroduce <DocumentationSection /> once the IT/procurement
          documentation is ready to publish. */}
      <InstitutionsFinalCTASection />
    </div>
  );
}
